import component from './CollapsableBlock.vue'
export default component
